import SparklesIcon from 'components/common/Icon/SparklesIcon';

export const AUTO_AI_ACTIVITIES = {
  AI_1: {
    value: 'scileads-ai-1',
    label: 'Let SciLeads AI choose 1 relevant activity',
    selectedLabel: 'SCILEADS AI 1 ACTIVITY',
    icon: <SparklesIcon style={{ marginRight: 8, verticalAlign: 'middle' }} />,
    count: 1,
  },
  AI_2: {
    value: 'scileads-ai-2',
    label: 'Let SciLeads AI choose 2 relevant activities',
    selectedLabel: 'SCILEADS AI 2 ACTIVITY',
    icon: <SparklesIcon style={{ marginRight: 8, verticalAlign: 'middle' }} />,
    count: 2,
  },
};

export const ALL_AUTO_AI_ACTIVITIES = Object.values(AUTO_AI_ACTIVITIES);
